import { useAuth0 } from "@auth0/auth0-react";
import AuthService from "Lib/API/Auth";
import { ReactComponent as PlusIcon } from 'assets/icons/plus.svg';
import AlertDialog from "components/Dialog";
import MainDialog from "components/Dialog/MainDialog";
import MyButton from "components/MyButton";
import Button from "components/button/Button";
import MainTabs from "components/mainTabs/MainTabs";
import { useUrlTab } from "hook/useUrlTab";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { toastr } from "react-redux-toastr";
import { useHistory } from "react-router-dom";
import { OverDueDaysCalculator } from "../../constants/enums";
import { SubHeader } from "../../layout/SubHeader";
import CurrentEvents from "./CurrentEvents";
import { addObject, changeStatus } from "./Events/eventSlice";
import "./index.scss";

const eventsTabs = [
  {
    id: "active",
    title: "Active",
    value: "active"
  },
  { 
    id: "archived",
    title: "Archived",
    value: "archived"
  },
];

const initialFilters = {
  sort: {},
  search: undefined,
};

export const Events = ({ ...props }) => {
  const { getAccessTokenSilently } = useAuth0();
  const [newClassName, setNewClassName] = React.useState("");
  const [error, setError] = React.useState("");
  const [nameError, setNameError] = React.useState("");
  const [activeTab, setActiveTab] = useState(0);
  const [archived, setArchived] = useState(false);
  const [duplicate, setDuplicate] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [data, setData] = useState({});
  const [added, setAdded] = React.useState(false);
  const [disabled, setDisabled] = useState(false);
  const [classesCount, setClassesCount] = useState(0);
  const [archivedCount, setArchivedCount] = useState(0);
  const [datePaid, setPaidRange] = useState([null, null]);
  const [startPaidDate, endPaidDate] = datePaid;
  const [dateRange, setDateRange] = useState([null, null]);
  const [startDate, endDate] = dateRange;
  const [filters, setFilters] = useState(initialFilters);
  const [searchValue, setSearchValue] = React.useState("");
  const [localFormat, setLocalFormat] = useState(false);
  const [financeTablePage, setFinanceTablePage] = useState(0);
  const [paymentExpandable, setPaymentExpandable] = useState(true);
  const [goSetting, setGoSetting] = useState(false);
  const [toggle, setToggle] = useState(true);
  // ?tab=active|archived opens that tab (e.g. from the global search)
  useUrlTab((tab) => setToggle(tab === "active"), eventsTabs.map((tab) => tab.value));
  const pageTab = toggle ? "account" : "people";
  const [archivedClassPage, setArchivedClassPage] = useState(0);
  const [activeClassPage, setActiveClassPage] = useState(0);

  const [sorting, setSorting] = useState({
    sort: {},
    search: undefined,
  });

  const history = useHistory();
  const dispatch = useDispatch();
  const handleCloseDialog = () => {
    setOpenDialog(false);
  };
  const handleSort = (name) => {
    setSorting((prev) => ({
      ...prev,
      sort: {
        [name]: prev.sort[name] === 1 ? -1 : 1,
      },
    }));
  };

  useEffect(() => {
    if (searchValue === "") {
      setSorting({ ...sorting, search: undefined });
    } else {
      setSorting({ ...sorting, search: searchValue });
    }
    toggle ? setActiveClassPage(0) : setArchivedClassPage(0);
  }, [searchValue]);
  
  const onClear = () => {
    setGoSetting(true);
    setFilters({ ...initialFilters });
  };

  const onSearchChange = (e) => {
    const name = e.target.value;
    setFilters((prev) => ({
      ...prev,
      search: name ? name : undefined,
    }));
  };

  useEffect(() => {
    if (startDate && endDate) {
      setFilters((prev) => ({
        ...prev,
        filter: {
          ...prev.filter,
          charge_date: {
            start: moment(startDate).format("MM/DD/YYYY"),
            end: moment(endDate).format("MM/DD/YYYY"),
          },
        },
      }));
    }
    if (startDate === null && endDate === null) {
      setFilters({
        sort: {},
        search: filters?.search,
      });
    }
  }, [startDate, endDate]);

  useEffect(() => {
    if (startPaidDate && endPaidDate) {
      setFilters((prev) => ({
        ...prev,
        filter: {
          ...prev.filter,
          paid_at: {
            start: moment(startPaidDate).format("MM/DD/YYYY"),
            end: moment(endPaidDate).format("MM/DD/YYYY"),
          },
        },
      }));
    }
    if (startPaidDate === null && endPaidDate === null) {
      setFilters({
        sort: {},
        search: filters?.search,
      });
    }
  }, [startPaidDate, endPaidDate]);

  const onChargeDateChange = (e) => {
    setLocalFormat(true);
    setFilters((prev) => ({
      ...prev,
      filter: {
        ...prev.filter,
        charge_date: e ? e?.target?.value : undefined,
      },
    }));
  };

  const onPaidDateChange = (e) => {
    setLocalFormat(true);
    setFilters((prev) => ({
      ...prev,
      filter: {
        ...prev.filter,
        paid_at: e ? e?.target?.value : undefined,
      },
    }));
  };

  const onLedgerAccountChange = (e) => {
    setFilters((prev) => ({
      ...prev,
      filter: {
        ...prev.filter,
        ledger: (typeof e === "string" ? e : e?.label) ?? undefined,
      },
    }));
  };

  const onAmountChange = (e) => {
    setFilters((prev) => ({
      ...prev,
      filter: {
        ...prev.filter,
        amount: e ? e : undefined,
      },
    }));
  };

  const onChargedStatusChange = (e) => {
    setFilters((prev) => ({
      ...prev,
      filter: {
        ...prev.filter,
        charge_status:
          e === "partially paid"
            ? "partially_paid"
            : e !== "partially paid"
            ? e
            : undefined,
      },
    }));
  };

  const onPaymentStatusChange = (e) => {
    setFilters((prev) => ({
      ...prev,
      filter: {
        ...prev.filter,
        payment_status:
          e === "partialy applied"
            ? "partially_applied"
            : e !== "partialy applied"
            ? e
            : undefined,
      },
    }));
  };

  const onOverdueDaysChange = (e) => {
    setFilters((prev) => ({
      ...prev,
      filter: {
        ...prev.filter,
        overdue: e ? OverDueDaysCalculator[e] : undefined,
      },
    }));
  };

  const sortCharged = (e) => {
    setFilters((prev) => ({
      ...prev,
      sort: {
        [e]: prev.sort[e] === 1 ? -1 : 1,
      },
    }));
  };

  const onStatusChange = (status) => {
    setFilters((prev) => ({
      ...prev,
      status: status !== "All" ? status.toLowerCase() : undefined,
    }));
    setFinanceTablePage(0);
    setPaymentExpandable(false);
  };

  const handleSubmit = async () => {
    const token = await getAccessTokenSilently();
    await AuthService.postDuplicate(data, token)
      .then((res) => {
        if (res) {
          setAdded(!added);
          setOpenDialog(false);
        }
      })
      .catch((err) => {
        setNameError(err.data.message);
        toastr.error("Error", err?.data?.message);
      });
  };

  const handleInputChange = (e) => {
    const inputValue = e.target.value;
    const regex = /[\*\(\)\+]/;
    if (!regex.test(inputValue)) {
      setSearchValue(inputValue);
    }
  };
  return (
    <div className="school-classes pt-5">
        <div className="header mt-5">
          <div className="header-tittle">
            <SubHeader
              className="class-tab subheader"
              {...{
                title: activeTab === 0 ? "Events" : "- Archived classes",
              }}
            />
          </div>
          <div className="new-class">
            <Button
                variant="primary"
                onClick={() => {
                  history.push('/create-new-event');
                  dispatch(changeStatus('create'));
                  dispatch(addObject([]));
                }}
              >
                <PlusIcon />
                <span>Add New Event</span>
            </Button>
          </div>
        </div>
        <MainTabs 
          className="mt-10"
          tabs={eventsTabs}
          activeTab={toggle ? 'active' : 'archived'}
          onTabsChange={(tab) => {
            setToggle(tab?.value === 'active');
          }}
        />
      <div>
        <CurrentEvents
          added={added}
          setClassesCount={setClassesCount}
          setDisabled={setDisabled}
          setData={setData}
          setOpenDialog={setOpenDialog}
          newClassName={newClassName}
          setError={setError}
          archived={archived}
          duplicate={duplicate}
          sortCharged={sortCharged}
          handleSort={handleSort}
          setSorting={setSorting}
          sorting={sorting}
          handleInputChange={handleInputChange}
          searchValue={searchValue}
          toggle={toggle}
          archivedClassPage={archivedClassPage}
          setArchivedClassPage={setArchivedClassPage}
          activeClassPage={activeClassPage}
          setActiveClassPage={setActiveClassPage}
        />
      </div>
      <MainDialog
        handleClose={handleCloseDialog}
        open={openDialog}
        onDecline={() => {
          setOpenDialog(false);
        }}
        onAccept={() => {
          if (newClassName) handleSubmit();
          else setNameError("Please Select a Name");
        }}
        content={
          <>
            <div className="">
              <p className=" py-10">
                Are you sure you want to duplicate the class?
              </p>
              <input
                style={{
                  background: "#F3F6F9",
                }}
                className="form-control form-control-solid h-auto py-5 px-6"
                onChange={(e) => {
                  setNewClassName(e.target.value);
                  setNameError("");
                }}
                placeholder="Class Name"
              />
              <div className="error-message">{nameError}</div>
            </div>
          </>
        }
      />
    </div>
  );
};
